import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningLead } from './components/OpeningLead';
import { PullQuote } from './components/PullQuote';
import { PainAgitation } from './components/PainAgitation';
import { DreamOutcome } from './components/DreamOutcome';
import { WhyMethodsFail } from './components/WhyMethodsFail';
import { MechanismReveal } from './components/MechanismReveal';
import { ProductIntroduction } from './components/ProductIntroduction';
import { OfferStack } from './components/OfferStack';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#FDF8F4] font-inter relative" data-id="element-0">
      {/* Ghost Background Image */}
      <div className="fixed inset-0 pointer-events-none z-0 opacity-[0.04]" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?q=80&w=2074&auto=format&fit=crop")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed'
    }} data-id="element-1" />

      {/* Content Wrapper */}
      <div className="relative z-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <OpeningLead data-id="element-4" />
        <PullQuote quote="La ansiedad no es quién eres. Es lo que tu cuerpo aprendió a hacer." data-id="element-5" />
        <PainAgitation data-id="element-6" />
        <PullQuote quote="No puedes pensar para salir de algo en lo que tu cuerpo te metió." data-id="element-7" />
        <DreamOutcome data-id="element-8" />
        <WhyMethodsFail data-id="element-9" />
        <MechanismReveal data-id="element-10" />
        <PullQuote quote="Tu mente no necesita que la convenzan. Necesita que la restablezcan." data-id="element-11" />
        <ProductIntroduction data-id="element-12" />
        <OfferStack data-id="element-13" />
        <Urgency data-id="element-14" />
        <PullQuote quote="La calma no es la ausencia de caos. Es un sistema que funciona dentro del caos." data-id="element-15" />
        <FinalCTA data-id="element-16" />
        <Footer data-id="element-17" />
      </div>
    </div>;
}